import {
    EnvironmentProviders,
    inject,
    Provider,
    provideEnvironmentInitializer,
} from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { ZOP_AUTH_CONFIG } from './zop-auth-config.provider';
import { ZopAuthLibConfig } from './config.types';

export const provideZopAuth = (
    config: ZopAuthLibConfig
): Array<Provider | EnvironmentProviders> => {
    // Base providers
    const providers: Array<Provider | EnvironmentProviders> = [
        {
            provide: ZOP_AUTH_CONFIG,
            useValue: config,
        },
        provideEnvironmentInitializer(() => inject(AuthService)),
    ];
    return providers;
};
